import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress benign ResizeObserver loop error by patching ResizeObserver
// This is a known browser quirk and not a real error
// See: https://github.com/WICG/resize-observer/issues/38

// Patch ResizeObserver to ignore the loop error
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Wrap callback in try-catch to suppress the error
      try {
        callback(entries, observer);
      } catch (error) {
        // Only suppress ResizeObserver loop errors
        if (error.message?.includes('ResizeObserver')) {
          console.debug('ResizeObserver loop error suppressed (benign)');
          return;
        }
        throw error;
      }
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
